export enum Actions {
  Accept,
  Archive,
  Activate,
  Copy,
  Delete,
  Edit,
  Load,
  Publish,
  View,
  Refresh,
  Filter,
  SilentFail,
  ExportData,
  ViewDraft
}
